export default () => {
  $('.about-section__text').mCustomScrollbar();
  $('.select .select__list').mCustomScrollbar();
  $('.table__body--scroll').mCustomScrollbar();
  $('.map-holder__aside').mCustomScrollbar();

  if ($(window).width() < '767') {
    $('.info-window__list').mCustomScrollbar();
  }

  // $(window).on('load resize', () => {
  //   if ($(window).width() < '767') {
  //     $('.page-nav--scroll ul, .tabs-list--product').mCustomScrollbar({
  //       axis:"x"
  //     });
  //   } else {
  //     // if (!$('.page-nav--scroll ul, .tabs-list--product').length) return;
  //     // $('.page-nav--scroll ul').mCustomScrollbar('destroy');
  //   }
  // });

  $(window).on('load resize', () => {
    if ($(window).width() < '1350') {
      $('.spare-products__inner, .basket-block__inner, .area-table__inner').mCustomScrollbar({
        axis:"x"
      });
    } else {
      if (!$('.spare-products__inner, .basket-block__inner, .area-table__inner').length) return;
      $('.spare-products__inner, .basket-block__inner, .area-table__inner').mCustomScrollbar('destroy');
    }
  });
}



// WEBPACK FOOTER //
// app/scripts/components/scroll.js